export default class UtilArray{

    /**
     * Quebra um array em grupos menores (chunks) de tamanho fixo.
     * Observação: este método altera o array original (uso de splice).
     * @param {Array} lista - Array de entrada.
     * @param {number} chunks - Tamanho de cada grupo.
     * @returns {Array<Array>} Novo array contendo os grupos.
     */
    static chunk(lista = [], chunks = 1){

        let chunkArray = [];
        while (lista.length) {
            chunkArray.push(lista.splice(0, chunks));
        }
        return chunkArray;

    }

    /**
     * Verifica se o array está vazio.
     * @param {Array} array - Array a ser verificado.
     * @returns {boolean} Retorna true quando o tamanho é 0.
     */
    static isEmpty(array = []){
        return array.length == 0 ? true : false
    }

    /**
     * Verifica se o array possui ao menos um item.
     * @param {Array} array - Array a ser verificado.
     * @returns {boolean} Retorna true quando o tamanho é maior que 0.
     */
    static isNotEmpty(array = []){
        return array.length > 0 ? true : false
    }

    /**
     * Retorna os valores únicos de um array (comparação por identidade).
     * @param {Array} array - Array de entrada.
     * @returns {Array} Novo array sem duplicidades.
     */
    static unique(array=[]){
        return [...new Set(array)];
    }

    static uniqueBy(array = [], property) {
        const map = new Map();

        for (const item of array) {
            map.set(item[property], item);
        }

        return [...map.values()];
    }

    /**
     * Obtém o último item do array.
     * @param {Array} array - Array de entrada.
     * @returns {*} Último item ou undefined se o array estiver vazio.
     */
    static getLast(array=[]){
        return array[array.length-1];
    }

    /**
     * Clona superficialmente cada item do array.
     * Indicado para arrays de objetos simples (não é clone profundo).
     * @param {Array<Object>} array - Array de objetos.
     * @returns {Array<Object>} Novo array com objetos clonados superficialmente.
     */
    static clone = (array = []) => {

        return array.map(any => {return {...any}});

    }

    /**
     * Remove do array os itens contidos na lista de valores a remover.
     * @param {Array} array - Array de origem.
     * @param {Array} valuesToRemove - Valores que devem ser removidos.
     * @returns {Array} Novo array sem os valores informados.
     */
    static removeList = (array = [], valuesToRemove = []) => {

        return array.filter(item => !valuesToRemove.includes(item));

    }

    /**
     * Verifica se o array contém o valor informado (===)
     * @param {Array} array - Array a ser verificado
     * @param {*} value - Valor a ser procurado
     * @returns {boolean}
     */
    static includes(array = [], value) {
        return array.includes(value);
    }

    /**
     * Verifica se o array NÃO contém o valor informado (===)
     * @param {Array} array - Array a ser verificado
     * @param {*} value - Valor a ser procurado
     * @returns {boolean}
     */
    static notIncludes(array = [], value) {
        return !array.includes(value);
    }

    /**
     * Verifica se o array contém apenas um valor (===), ignorando falsy/undefined/null para o array.
     * @param {Array} arr - Array a ser verificado
     * @param {*} value - Valor a ser comparado
     * @returns {boolean}
     */
    static hasOnly(arr=[], value="") {
        if (!Array.isArray(arr)) return false;
        return arr.length === 1 && arr[0] === value;
    }

    /**
     * Concatena múltiplos arrays em um único array.
     * @param {...Array} arrays - Arrays a serem concatenados.
     * @returns {Array} Novo array com a junção dos arrays recebidos.
     */
    static concat(...arrays) {

        return [].concat(...arrays);

    }

}